@if (feedbackListings && feedbackListings.length > 0) {
  <div class="tw:container tw:mx-auto tw:px-[15px]">
    @for (feedback of feedbackListings; track feedback; let isFirst = $first) {
      <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:my-4 listing-container cursor-pointer">
        <div class="tw:w-full tw:px-[15px]" (click)="toggleBar(surveyContainer, feedback)">
          <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:py-4 summary-container">
            <div class="tw:flex-1 tw:px-[15px] header-icon-container">
              <div [ngClass]="{'tuition-icon': feedback.surveyType == 'TUITION', 'session-icon': feedback.surveyType == 'SESSION'}"></div>
            </div>
            <div class="tw:flex-1 tw:px-[15px]">
              <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
                <div class="tw:w-full tw:px-[15px] tw:md:w-1/2">
                  <label class="listing-header-label">{{feedback.feedbackSurvey.feedbackSurveyTitle}}</label>
                </div>
                <div class="tw:w-full tw:px-[15px] tw:md:w-1/2">
                  @if (feedback.surveyType == 'TUITION') {
                    <label class="listing-header-label">{{ feedback.startDate | date : 'dd MMM yyyy'}} - {{ feedback.endDate | date : 'dd MMM yyyy'}}</label>
                  }
                  @if (feedback.surveyType == 'SESSION') {
                    <label class="listing-header-label">{{ feedback.startDate | date : 'dd MMM yyyy'}} {{ feedback.startDate | date : 'HH:mm'}} - {{ feedback.endDate | date : 'HH:mm'}}</label>
                  }
                </div>
                <div class="tw:w-full tw:px-[15px] tw:md:w-1/2">
                  <label class="listing-header-label">Subject - {{feedback.subject}}</label>
                </div>
                <div class="tw:w-full tw:px-[15px] tw:md:w-1/2">
                  <label class="listing-header-label">{{themeService.siteContent.placementHeaderLabel}} Id - {{feedback.bookingId}}</label>
                </div>
              </div>
            </div>
            <div class="tw:flex-1 tw:px-[15px] toggle-container">
              <div [ngClass]="{'chevron-close-icon': feedback.expanded, 'chevron-open-icon': !feedback.expanded}"></div>
            </div>
          </div>
        </div>
        <div class="tw:w-full tw:px-[15px] survey-bar" #surveyContainer
          [ngClass]="{'hide-survey tw:hidden': !isFirst}">
          <tuition-feedback [survey]="feedback.feedbackSurvey" (feedbackSubmitted)="feedbackSubmitted($event)"></tuition-feedback>
        </div>
      </div>
    }
  </div>
}

@if (!feedbackListings || feedbackListings.length == 0) {
  <div class="tw:w-full tw:px-[15px] tw:mx-auto tw:h-full not-found-master-container">
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:h-full">
      <div class="tw:w-full tw:px-[15px] tw:my-auto tw:mx-auto tw:py-6 not-found-container">
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:justify-center tw:items-center">
          <div class="tw:w-full tw:px-[15px] tw:py-2 tw:flex tw:justify-center tw:items-center">
            <h2 class="not-found-header">Your Voice</h2>
          </div>
          <div class="tw:w-full tw:px-[15px] tw:py-2 tw:flex tw:justify-center tw:items-center">
            @if (!studentHasNeverCompletedSurveys) {
              <label class="not-found-sub-text">You have completed all of your current feedback</label>
            }
            @if (studentHasNeverCompletedSurveys) {
              <label class="not-found-sub-text">You have no feedback available to submit</label>
            }
          </div>
          <div class="tw:w-full tw:px-[15px] tw:py-2 tw:flex tw:justify-center tw:items-center">
            <label class="not-found-sub-text">please come back later</label>
          </div>
          <div class="tw:w-full tw:px-[15px] tw:my-1">
            <div class="not-found-gif-container tw:mx-auto">
              <thank-you-banner [generateOnShow]="!studentHasNeverCompletedSurveys"></thank-you-banner>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}